module.exports = __webpack_public_path__ + "static/media/logo-transparent.8d4b67f3.png";